function getShouldEnterCropMode(editor) {
  const onlySelectedShape = editor.getOnlySelectedShape();
  return !!(onlySelectedShape && !editor.isShapeOrAncestorLocked(onlySelectedShape) && editor.getShapeUtil(onlySelectedShape).canCrop(onlySelectedShape));
}
export {
  getShouldEnterCropMode
};
//# sourceMappingURL=getShouldEnterCropModeOnPointerDown.mjs.map
